<template>
    <div>
        <div class="grid-preview">
            <div class="template-preview">
                <div :style="calcStyle(item)" :class="calcClass(item)" v-for="item in c_layout" :key="item.i">
                    <div class="ql-editor" v-if="item.e" v-html="item.cd.value.content"></div>
                    <component v-else :is="item.cp" v-bind="{...item.cd,editing:item.editing}">
                        <slot v-if="item.s"></slot>
                    </component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TemplateGeneratorLogo from "./TemplateGeneratorLogo.vue"
import TemplateGeneratorName from "./TemplateGeneratorName.vue"
import TemplateGeneratorTodayDate from "./TemplateGeneratorTodayDate.vue"
import TemplateGeneratorContent from "./TemplateGeneratorContent.vue"
import TemplateGeneratorDivider from "./TemplateGeneratorDivider.vue"
import TemplateGeneratorTextPreview from "./TemplateGeneratorTextPreview"
import TemplateGeneratorSpace from "./TemplateGeneratorSpace"

export default {
    components:{
        TemplateGeneratorLogo,
        TemplateGeneratorName,
        TemplateGeneratorTodayDate,
        TemplateGeneratorDivider,
        TemplateGeneratorContent,
        TemplateGeneratorTextPreview,
        TemplateGeneratorSpace,
    },
    props:{
        layout:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            colNum:12,
            rowHeight:30,
            gridTemplate:{}
        }
    },
    methods:{
        calcClass(item){
            return "gp-"+item.id
        },
        calcStyle(item){
            let height = (item.h * this.rowHeight) + "px"
            if(item.ah){ height = "auto" }

            let itemPoints = this.getItemPoints(item)

            return {
                'height':height,
                'grid-column-start': itemPoints.colStart,
                'grid-column-end': itemPoints.colEnd,
                'grid-row-start': itemPoints.rowStart,
                'grid-row-end': itemPoints.rowEnd
            }
        },
        getItemPoints(item){
            return{
                colStart:item.x + 1,
                colEnd:item.x + item.w + 1,
                rowStart:item.y + 1,
                rowEnd:item.y + item.h + 1,
            }
        },
    },
    computed:{
        c_maxRow(){
            return Math.max(...this.c_layout.map(l=>l.y + l.h))
        },
        c_layout(){
            return JSON.parse(this.layout)   
        },
    },
}
</script>

<style>
.template-preview{
    padding: 10px;
    border: 1px solid rgba(0,0,0,0.25);
    display: grid;
    grid-template-columns:repeat(12,1fr);
}
</style>